import { notify } from 'utils/notify'
export default (text, notificationMsg) => {
  if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(() => {
      if (notificationMsg) {
        notify('Clipboard', { message: notificationMsg })
      }
      return true
    }, (err) => {
      console.warn('Failed to copy the text to clipboard.', { message: err, type: 'error' })
      return false
    })
  } else {
    console.warn('navigator.clipboard.writeText is not available.')
  }
}
